import { render } from "./IndividualReport.vue?vue&type=template&id=dec0fd6c"
import script from "./IndividualReport.vue?vue&type=script&lang=js"
export * from "./IndividualReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__